import styled from "@emotion/styled";
import { SxProps } from "@mui/material";
import MuiButton from "@mui/material/Button";
import React from "react";
import ParkkiTheme from "themes/ParkkiTheme";

const StyledButton = styled(MuiButton)`
  text-transform: none;
  font-weight: normal;
  color: ${ParkkiTheme.colors.white};
  opacity: 0.85;

  &.Mui-disabled {
    color: rgba(0, 0, 0, 0.3);
    background-color: rgb(229, 229, 229);
  }
`;

type Props = {
  label?: string | React.ReactNode;
  disabled?: boolean;
  size: "small" | "large" | "medium" | undefined;
  color:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning"
    | undefined;
  startIcon?: JSX.Element;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  fullWidth?: boolean;
  type?: "button" | "reset" | "submit" | undefined;
  sx?: SxProps;
};

function Button({ label, ...rest }: Props): JSX.Element {
  return <StyledButton {...rest}>{label}</StyledButton>;
}

Button.defaultProps = {
  variant: "contained",
  color: "primary",
  fullWidth: true,
};

export default Button;
